import React from "react";

const Footer = () => {
  return (
    <div class="container-fluid bg-dark text-white-50 footer pt-5">
      <div class="container py-5">
        <div class="row g-5">
          <div class="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
            <a href="index.html" class="d-inline-block mb-3">
              <h1 class="text-white">
                i<span class="text-primary"></span>Detect
              </h1>
            </a>
          </div>
          <div class="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
            <h5 class="text-white mb-4">Get In Touch</h5>
            <p>Fleming, Alexandria, Egypt</p>

            <p>Mayarmagdy609@gmail.com</p>
          </div>
          <div class="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
            <h5 class="text-white mb-4">Popular Link</h5>
            <a class="btn btn-link" href="#hero">
              About Us
            </a>
            <a class="btn btn-link" href="#hero">
              Contact Us
            </a>
            <a class="btn btn-link" href="#hero">
              Privacy Policy
            </a>
            <a class="btn btn-link" href="#hero">
              Terms & Condition
            </a>
            <a class="btn btn-link" href="#hero">
              Career
            </a>
          </div>
          <div class="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
            <h5 class="text-white mb-4">Our Services</h5>
            <a class="btn btn-link" href="#hero">
              Robotic Automation
            </a>
            <a class="btn btn-link" href="#hero">
              Machine learning
            </a>
            <a class="btn btn-link" href="#hero">
              Predictive Analysis
            </a>
            <a class="btn btn-link" href="#hero">
              Data Science
            </a>
            <a class="btn btn-link" href="#hero">
              Robot Technology
            </a>
          </div>
        </div>
      </div>
      <div class="container wow fadeIn" data-wow-delay="0.1s">
        <div class="copyright">
          <div class="row">
            <div class="col-md-6 text-center text-md-start mb-3 mb-md-0">
              &copy;{" "}
              <a class="border-bottom" href="##hero">
                Mayar Magdy
              </a>
              , All Right Reserved.
            </div>
            <div class="col-md-6 text-center text-md-end">
              <div class="footer-menu">
                <a href="#hero">Home</a>
                <a href="#hero">Cookies</a>
                <a href="#hero">Help</a>
                <a href="#hero">FAQs</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
